import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { WixEmbedsAPISiteConfig } from '../types'

const wixEmbedsApiSiteConfig: SiteConfigFn<WixEmbedsAPISiteConfig> = ({ api, funcLib }) => {
	const isAdminPage = funcLib.getQueryParamValue(api.originalRequest.getUrl(), 'inBizMgr') === 'true'

	return {
		siteConfig: { isAdminPage },
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
	}
}

const disabledSiteConfig: SiteConfigFn<Record<string, never>> = () => ({
	shouldLoadSiteFeature: false,
	shouldLoadSiteConfig: false,
	siteConfig: null,
})

const name = 'wixEmbedsApi'

export const config = {
	site: wixEmbedsApiSiteConfig,
	reactRendererSite: disabledSiteConfig,
	name,
}
